import { REQUEST_API_URL } from '@fukuri-admins/constants/common';
import { setToken } from '@fukuri-admins/utils/common/cookies';
import * as Sentry from '@sentry/react';

const BEARER_PREFIX = 'Bearer ';
export type LoginFormType = {
  client_admin_user: {
    email: string;
    password: string;
    code: string;
  };
};

export async function login(loginForm: LoginFormType) {
  const response: Response = await fetch(REQUEST_API_URL + '/client_admins/sign_in', {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(loginForm),
  });

  if (!response.ok) {
    Sentry.captureException(new Error(`${response.status} ${response.statusText}`));
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const authHeader = response.headers.get('Authorization');
  const token = authHeader.substring(BEARER_PREFIX.length);
  setToken(token, {
    path: '/',
    sameSite: 'strict',
  });

  return response;
}
